import type { SchemaBuilderFormModalProps } from "./schema-builder-form-modal.type";

import { Modal } from "antd";
import cn from "classnames";

import "./schema-builder-form-modal.style.less";

export const SchemaBuilderFormModal = ({
  className,
  classNames,
  ...modalProps
}: SchemaBuilderFormModalProps) => {
  return (
    <Modal
      width="90vw"
      centered
      {...modalProps}
      className={cn("schema-builder-form-modal", className)}
      classNames={{
        ...classNames,
        container: cn(
          "schema-builder-form-modal--container",
          classNames?.container
        ),
        body: cn("schema-builder-form-modal--body", classNames?.body),
        footer: cn("schema-builder-form-modal--footer", classNames?.footer),
        close: cn("schema-builder-form-modal--close", classNames?.close),
      }}
    />
  );
};
